var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-loader',{attrs:{"method":"get","url":("v1/grazings/" + _vm.grazingId)},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var grazing = ref.result;
return [_c('grazing',{attrs:{"grazing":grazing}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fd833c3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/grazing/views/GrazingView.vue
// module id = null
// module chunks = 